import { render } from "./LimitationView.vue?vue&type=template&id=9bc1c90e"
import script from "./LimitationView.vue?vue&type=script&lang=js"
export * from "./LimitationView.vue?vue&type=script&lang=js"

import "./LimitationView.vue?vue&type=style&index=0&id=9bc1c90e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__